
export default function ServicesHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-[#4A6B58] to-primary overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-warm-200 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-12 text-center">
        <h1 className="text-6xl lg:text-7xl font-black text-white mb-6 font-serif">
          專業服務項目
        </h1>
        <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          從舊屋改造到軟裝搭配，提供一站式整合服務<br />
          讓您的家煥然一新，真正完成入住
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#old-house"
            className="px-6 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all backdrop-blur-sm whitespace-nowrap"
          >
            舊屋改造
          </a>
          <a
            href="#bathroom"
            className="px-6 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all backdrop-blur-sm whitespace-nowrap"
          >
            浴室改造
          </a>
          <a
            href="#turnkey"
            className="px-6 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all backdrop-blur-sm whitespace-nowrap"
          >
            室內裝修統包
          </a>
          <a
            href="#soft-decoration"
            className="px-6 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all backdrop-blur-sm whitespace-nowrap"
          >
            居家軟裝設計
          </a>
          <a
            href="#rental"
            className="px-6 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all backdrop-blur-sm whitespace-nowrap"
          >
            出租裝修服務
          </a>
        </div>
      </div>
    </section>
  );
}
